import React, { useContext } from "react";
import PropTypes from "prop-types";

import { useHotKeys } from "App/common/hooks/hotKeys";
import { EDIT_BACKUP_SETTINGS } from "App/componentsConfig";
import { SPopupContext } from "App/common/hoc/SlidingPopup";
import Footer from "./Footer";
import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";
import { forbidExtraProps } from "utils";

function Edit(props) {
  const panel = EDIT_BACKUP_SETTINGS[props.currentPanel.type];
  const { sPopupState } = useContext(SPopupContext);

  useHotKeys(
    "backspace",
    e => {
      e.preventDefault();
      switchPanel();
    },
    [sPopupState]
  );

  function switchPanel() {
    if (!sPopupState.disableClose.close) {
      if (sPopupState.disableClose.params.display("backToSummary")) {
        props.switchPanel("summary");
      }
    } else props.switchPanel("summary");
  }

  return (
    <div
      className={"summary_wrap summary_" + panel.class}
      style={{ display: "block" }}
    >
      <div className="summary_wrap_body">
        <div className="summary_wrap_body__title">
          <Tooltip {...TOOLTIPS.backupSettings.back}>
            <div className="summary_wrap_back" onClick={() => switchPanel()} />
          </Tooltip>
          <div className="sub_title">{panel.name}</div>
        </div>

        {React.createElement(panel.component)}
      </div>

      <Footer
        {...{
          switchPanel: props.switchPanel,
          currentPanel: props.currentPanel
        }}
      />
    </div>
  );
}

Edit.propTypes = forbidExtraProps(
  {
    currentPanel: PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.string
    }).isRequired
  },
  ["switchPanel"]
);

export default Edit;
